<script setup lang="ts">
const head = useLocaleHead({ dir: true, seo: true, lang: true });
const directionRef = computed<"rtl" | "ltr">(
  () => (head.value.htmlAttrs?.dir as "ltr" | "rtl") ?? "ltr",
);
const langRef = computed(() => head.value.htmlAttrs?.lang ?? "en");
const htmlStyle = computed(() => `--direction: ${directionRef.value};`);
useHead({
  htmlAttrs: {
    lang: langRef,
    dir: directionRef,
    style: htmlStyle,
  },
});
useProvideLangDir(directionRef);
</script>
<template>
  <NuxtLayout>
    <subscription-banner />
    <settings-user-menu />
    <NuxtPage />
  </NuxtLayout>
</template>
